import { LabelProps } from "@hightouch/formkit";
import { Text } from "@hightouch/htui";
import { SharedProps } from ".";

export const FKLabel = ({
  message,
  color,
  size,
  fontWeight,
}: LabelProps & SharedProps) => (
  <Text size={size} color={color} fontWeight={fontWeight}>
    {message}
  </Text>
);
